export const pollRefreshStatusCode = 410;

export const handlePollModeRefresh = () => {
    window.location.reload();
}